module.exports = {
  secret: "pushpoliticscanada"
};
